const STORAGE_KEY = 'adaptive-domain-selected';

function getStorage() {
    try {
        return window.localStorage || null;
    } catch (e) {
        return null;
    }
}

export default class DomainSwitcherAutoSuggestion {

    constructor(root) {
        this.root = root;
        this.run();
    }

    run() {
        this.storage = getStorage();

        if (this.storage === null) {
            return;
        }

        try {
            if (this.storage.getItem(STORAGE_KEY) === '1') {
                return;
            }
        } catch (e) {
            return;
        }

        const template = document.querySelector('[data-domain-switcher-auto-suggestion-template]');

        if (template === null) {
            return;
        }

        this.openModal(template);
    }

    openModal(template) {
        const modalInstance = new window.aui.modal({
            title: template.dataset.domainSwitcherTitle,
            class: 'aui-domain-switcher-modal aui-domain-switcher-modal--suggestion',
            body: template.innerHTML,
            type: 'sm',
            selfClose: false,
            onClose: () => {
                try {
                    this.storage.setItem(STORAGE_KEY, '1');
                } catch (e) {
                    // do nothing
                }
            },
        });

        modalInstance.options.el.addEventListener('click', (event) => {
            if (event.target.closest('[data-domain-switcher-stay]')) {
                modalInstance.close();
            }
        });
    }

    static init(container) {
        container.querySelectorAll('[data-domain-switcher-auto-suggestion]').forEach((root) => {
            new DomainSwitcherAutoSuggestion(root);
        });
    }

}

naja.addEventListener('init', () => {
    DomainSwitcherAutoSuggestion.init(document.body);
});
